import { Head, Link } from "@inertiajs/react"
import { AppLayout } from "@/layouts/app-layout"
import { PageHeader } from "@/hooks/use-page-header"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Pencil } from "lucide-react"
import type { ProjectContact } from "@/types"

type Props = {
  contact: ProjectContact
}

function ContactShow({ contact }: Props) {
  return (
    <>
      <Head title={contact.display_name} />
      <PageHeader title={contact.display_name} back="/contacts" />
      <div className="space-y-6">
        <div className="flex items-center justify-end">
          <Button asChild>
            <Link href={`/contacts/${contact.id}/edit`}>
              <Pencil className="size-4" />
              Modifier
            </Link>
          </Button>
        </div>

        <div className="grid gap-6 md:grid-cols-2">
          <Card>
            <CardHeader>
              <CardTitle>Informations</CardTitle>
            </CardHeader>
            <CardContent className="space-y-3">
              {contact.first_name && (
                <div>
                  <p className="text-muted-foreground text-sm">Prénom</p>
                  <p>{contact.first_name}</p>
                </div>
              )}
              <div>
                <p className="text-muted-foreground text-sm">Nom</p>
                <p>{contact.last_name || "—"}</p>
              </div>
              {contact.role && (
                <div>
                  <p className="text-muted-foreground text-sm">Rôle</p>
                  <p>{contact.role}</p>
                </div>
              )}
              <div>
                <p className="text-muted-foreground text-sm">Organisation</p>
                <p>{contact.organisation?.name || "—"}</p>
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle>Contact</CardTitle>
            </CardHeader>
            <CardContent className="space-y-3">
              <div>
                <p className="text-muted-foreground text-sm">Email</p>
                <p>{contact.email || "—"}</p>
              </div>
              <div>
                <p className="text-muted-foreground text-sm">Téléphone</p>
                <p>{contact.phone_number || "—"}</p>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </>
  )
}

ContactShow.layout = (page: React.ReactNode) => <AppLayout>{page}</AppLayout>

export default ContactShow
